<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <filter-by-status-header
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Văn bản dự thảo'"
            @filterByStatus="filterByStatus"
          />
          <!--          <div class="leftSection">-->
          <!--            <div class="header-title wrapper-content__main font-weight__bold">-->
          <!--              Văn bản dự thảo đã xóa-->
          <!--            </div>-->
          <!--          </div>-->
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection flex-row">
                  <el-button
                    size="medium"
                    type="danger"
                    v-show="countVbanChecked > 0"
                    @click="deleteMultiple"
                  >
                    <i class="fa fa-trash"></i>
                    <span>Xóa</span>
                  </el-button>
                </div>

                <search
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div
                      class="flex-row flex-left__top margin-right-10 custom-label__input fix-width__large"
                    >
                      <span class="label-input width__auto">Ngày tạo</span>
                      <el-date-picker
                        v-model="createTimeRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="right"
                        :clearable="false"
                        @change="createTimeRangeChanged"
                      ></el-date-picker>
                    </div>
                  </template>
                  <template #advance>
                    <doc-out-achievement-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </search>
              </template>
            </sub-header>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <transition name="fade-in">
                    <div :class="['theTitle theTitle__lv5']">
                      <span class="stt margin-left-10" v-show="!hasExistChecked"
                        >STT</span
                      >
                      <div
                        :class="['flex-row flex__center checkbox']"
                        v-show="hasExistChecked"
                      >
                        <el-checkbox
                          :class="['checkboxVBan']"
                          v-model="checkAll"
                          @change="checkAllVBan"
                        ></el-checkbox>
                      </div>
                    </div>
                  </transition>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'" />
                  </div>
                </div>
                <div class="rightSection flex-row flex__right">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__right clickable"
                    @click="doSort('createTime')"
                  >
                    Ngày tạo
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'createTime'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in vbOutgoingDocs"
                    v-bind:key="item.id"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div
                          class="flex-row flex__left stt"
                          v-show="!hasExistChecked"
                        >
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                              $itemIndex + 1
                            }}</span>
                          </div>
                        </div>
                        <div
                          :class="[
                            'flex-row flex__center checkbox',
                            hasExistChecked ? '' : 'hover'
                          ]"
                        >
                          <el-checkbox
                            :class="['checkboxVBan']"
                            v-model="item.checkVBan"
                            @click.stop.native="() => true"
                            @change="checked"
                          ></el-checkbox>
                        </div>
                      </div>
                      <div class="theTitle__lv1">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left">
                            <el-tag
                              v-if="item.docTypeName"
                              size="medium"
                              class="margin-right-5"
                              >{{ item.docTypeName }}
                            </el-tag>

                            <doc-priority-tag
                              v-if="!!item.priorityName"
                              :priorityName="item.priorityName"
                              :priorityId="item.priorityId"
                              class="margin-right-5"
                            >
                            </doc-priority-tag>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv2 flex-row flex__right font-size__small"
                      >
                        <div class="flex-row flex__right txt-right">
                          <i
                            class="color__blue fas fa-clock margin-right-5"
                          ></i>
                          {{
                            item.createTime | dateFormatter({ nullValue: "-" })
                          }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
    </template>
  </list-template>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import MainHeader from "../../../components/header/main-header";
import SubHeader from "../../../components/main/sub-header";
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import { EventBus } from "../../../event-bus";
import dateFormatter from "../../../filters/dateFormatter";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import h from "../../../services/h";
import outgoingDocService from "../../../services/outgoingDocService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import utils from "../../../services/utils";
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import ListTemplate from "../../common/list";
import Search from "../../common/search";
import SortCaret from "../../doc-out/SortCaret";
import FilterByStatusHeader from "../components/filter-by-status-header";
import DocOutAchievementAdvanceSearchDialog from "./doc-out-achievement-advance-search-dialog";
import DocPriorityTag from "./doc-priority-tag";

export default {
  name: "tdhvp-doc-out-index",
  components: {
    FilterByStatusHeader,
    DocOutAchievementAdvanceSearchDialog,
    BreakWordSpan,
    DocPriorityTag,
    SortCaret,
    Search,
    SubHeader,
    MainHeader,
    ListTemplate,
    VuePerfectScrollbar
  },
  filters: { dateFormatter },

  data() {
    return {
      dateQuickFilterOption: null,
      createTimeRange: null,
      vbOutgoingDocs: [],
      advanceSearchForm: {
        fromCreateTime: null,
        toCreateTime: null,
        quote: null,
        docTypeId: null
      },
      keyword: null,
      order: null,
      sort: null,
      page: null,
      size: 10,
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      filterOptions: [
        {
          value: constants.DU_THAO_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.CHO_XU_LY,
          label: "Chờ xử lý",
          iconClass: "fa-clock"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.DA_XU_LY,
          label: "Đã xử lý",
          iconClass: "fa-check-circle"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.PHOI_HOP,
          label: "Phối hợp"
          // iconClass: "fa-check-circle"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.DA_XOA,
          label: errorMessageFilter({
            errorCode: "vbOutgoingDoc.filterByStatus.daXoa"
          }),
          iconClass: "fa-trash"
        }
      ],
      filterStatus: constants.DU_THAO_PAGE.FILTER.DA_XOA,
      countVbanChecked: 0,
      checkAll: false
    };
  },

  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },
    hasExistChecked() {
      return this.countVbanChecked > 0;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      if (newValue) this.isEnableAdvanceSearchDialog = true;
    }
  },

  created() {
    this.dateQuickFilterOption = utils.getDefaultDateQuickFilterOption();
    this.initQuery();
    this.initFilterOptions();
  },

  mounted() {
    EventBus.$on(this.parentRoute, () => {
      this.doSearch();
    });
  },

  methods: {
    deleteMultiple() {
      return utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbOutgoingDoc.permanentDeleteMultiple.confirm"
          })
        )
        .then(() => {
          let checkedDocs = h.findAll(
            this.vbOutgoingDocs,
            item => item.checkVBan
          );
          Promise.all(
            h.collect(checkedDocs, (item, index) => {
              return this.delete_(item, index).then(({ isSuccess, error }) => {
                if (isSuccess) {
                  this.vbOutgoingDocs.splice(
                    this.vbOutgoingDocs.indexOf(item),
                    1
                  );
                }
              });
            })
          ).then(() => {
            this.countVbanChecked = h.count(
              this.vbOutgoingDocs,
              item => item.checkVBan
            );
            this.checkAll =
              this.countVbanChecked ===
              (this.vbOutgoingDocs ? this.vbOutgoingDocs.length : 0);
          });
        });
    },

    delete_(doc, index) {
      return new Promise(resolve => {
        // setTimeout(() => {
        //   if (index % 2 === 0) {
        //     this.$message.success(
        //       errorMessageFilter({
        //         errorCode: "vbOutgoingDoc.permanentDelete.success"
        //       })
        //     );
        //     resolve({isSuccess: true});
        //   } else {
        //     this.$message.error(
        //       errorMessageFilter({
        //         errorCode: "vbOutgoingDoc.permanentDelete.failed"
        //       })
        //     );
        //     resolve({isSuccess: false});
        //   }
        // }, 2000);

        outgoingDocService
          .permanentDelete(doc.id)
          .then(() => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.permanentDelete.success"
              })
            );
            resolve({ isSuccess: true });
          })
          .catch(error => {
            this.$message.error(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.permanentDelete.failed"
              })
            );
            resolve({ isSuccess: false, error: error });
          });
      });
    },

    checked(value) {
      this.countVbanChecked += value ? 1 : -1;
      this.checkAll =
        this.countVbanChecked ===
        (this.vbOutgoingDocs ? this.vbOutgoingDocs.length : 0);
    },

    checkAllVBan(value) {
      h.each(this.vbOutgoingDocs, item => {
        this.$set(item, "checkVBan", value);
      });

      if (value) {
        this.countVbanChecked = this.vbOutgoingDocs
          ? this.vbOutgoingDocs.length
          : 0;
      } else {
        this.countVbanChecked = 0;
      }
    },

    /**
     * neu la quyen lanh dao thi moi them tab uy quyen;
     */
    initFilterOptions() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then(response => {
          let userDeptRoleView = response.data;
          userDeptRoleView.roleCode === constants.ROLE.CODE.LANH_DAO &&
            this.filterOptions.push({
              value: constants.DU_THAO_PAGE.FILTER.UY_QUYEN,
              label: "Ủy quyền",
              iconClass: null
            });
        });
    },

    filterByStatus({ filterStatus }) {
      switch (filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.DA_XOA:
          break;

        default:
          this.routingToDuThaoPage(filterStatus);
          break;
      }
    },

    routingToDuThaoPage(filterStatus) {
      console.log(filterStatus);
      this.$router.replace({
        name: "vbDuThaoNew",
        params: {
          userDeptRoleId: this.userDeptRoleId
        },
        query: { filterStatus }
      });
    },

    viewDetail(item) {
      this.$router.push({
        name: "deletedDocOutDetail",
        params: { id: item.id, userDeptRoleId: this.userDeptRoleId },
        query: this.$route.query
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };

      return outgoingDocService
        .findAllByAchievement(this.convertToSubmitForm(), pageable)
        .then(response => {
          let items = response.data;
          items && this.vbOutgoingDocs.push(...items);
          return items;
        });
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    doSearch() {
      //store lại tham số lên url;
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.convertToQueryParams()
      });
      this.vbOutgoingDocs = [];
      this.page = 0;
      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    doSort(sort) {
      this.sort = sort;
      this.order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.doSearch();
    },

    simpleSearch(keyword) {
      this.keyword = keyword;
      this.advanceSearchForm.quote = null;
      this.advanceSearchForm.docTypeId = null;
      this.doSearch();
    },

    createTimeRangeChanged() {
      utils.timeRangeChanged(this.createTimeRange, (from_, to_) => {
        this.advanceSearchForm.fromCreateDate = from_;
        this.advanceSearchForm.toCreateTime = to_;
      });
      this.doSearch();
    },

    advanceSearch(advanceSearchForm) {
      this.isOpenAdvanceSearchDialog = false;
      this.advanceSearchForm.docTypeId = advanceSearchForm.docTypeId;
      this.advanceSearchForm.quote = advanceSearchForm.quote;
      this.advanceSearchForm.fromCreateDate = advanceSearchForm.fromCreateDate;
      this.advanceSearchForm.toCreateTime = advanceSearchForm.toCreateTime;
      this.initDocDateRange();
      this.doSearch();
    },

    convertToSubmitForm() {
      return {
        docTypeId: this.advanceSearchForm.docTypeId,
        fromCreateTime: this.advanceSearchForm.fromCreateTime,
        toCreateTime: this.advanceSearchForm.toCreateTime,
        quote: this.advanceSearchForm.quote,
        keyword: this.keyword
      };
    },

    convertToQueryParams() {
      return {
        docTypeId: this.advanceSearchForm.docTypeId || undefined,
        fromCreateTime: this.advanceSearchForm.fromCreateTime || undefined,
        toCreateTime: this.advanceSearchForm.toCreateTime || undefined,
        quote: this.advanceSearchForm.quote || undefined,
        keyword: this.keyword || undefined,
        order: this.order,
        sort: this.sort
      };
    },

    initQuery() {
      let query = this.$route.query;
      this.advanceSearchForm.docTypeId = utils.getParamFromQuery(
        query,
        "docTypeId"
      );
      this.advanceSearchForm.quote = utils.getParamFromQuery(query, "quote");
      this.keyword = utils.getParamFromQuery(query, "keyword");
      this.advanceSearchForm.fromCreateTime = utils.getIntParamsFromQuery(
        query,
        "fromCreateTime"
      );
      this.advanceSearchForm.toCreateTime = utils.getIntParamsFromQuery(
        query,
        "toCreateTime"
      );
      this.sort = utils.getParamFromQuery(query, "sort");
      this.order = utils.getParamFromQuery(query, "order");
      this.initDocDateRange();
    },

    initDocDateRange() {
      if (
        !this.advanceSearchForm.fromCreateTime ||
        !this.advanceSearchForm.toCreateTime
      ) {
        utils.timeRangeChanged(
          (this.createTimeRange = dateUtils.getDatesByQuickFilter(
            constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
          )),
          (from_, to_) => {
            this.advanceSearchForm.fromCreateTime = from_;
            this.advanceSearchForm.toCreateTime = to_;
          }
        );
      } else {
        this.createTimeRange = [
          new Date(this.advanceSearchForm.fromCreateTime),
          new Date(this.advanceSearchForm.toCreateTime)
        ];
      }
    }
  }
};
</script>

<style scoped>
.item .checkbox.hover {
  display: none;
}

.item:hover .stt {
  display: none;
  transition: 0.5s;
}

.item:hover .checkbox.hover {
  display: flex;
  transition: 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/achievement/doc-out-achievement-index.vue